import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TableResponse } from '../components/table/table.interface';
import {
  CompanyDistributorsResponse,
  SalesSheetType,
  SalesSheetUploadResponse,
} from '../interfaces/apis/sales-sheet';

@Injectable({ providedIn: 'root' })
export class SalesSheetService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  getCompanyDistributors(): Observable<CompanyDistributorsResponse> {
    const params = new HttpParams().set('returnAll', true);
    return this.http.get<CompanyDistributorsResponse>(
      `${this.baseUrl}/company-distributor/base/company`,
      { params },
    );
  }

  upload(
    distributorId: string,
    sheetType: SalesSheetType,
    file: File,
  ): Observable<SalesSheetUploadResponse> {
    const formData = new FormData();
    formData.append('distributorId', distributorId);
    formData.append('sheetType', sheetType);
    formData.append('file', file);

    return this.http.post<SalesSheetUploadResponse>(
      `${this.baseUrl}/sale/base/upload`,
      formData,
    );
  }

  getInvalidRows(salesSheetId: string): Observable<TableResponse> {
    return this.http.post<TableResponse>(
      `${this.baseUrl}/sales-sheet/tables/${encodeURIComponent(salesSheetId)}/invalid-rows`,
      {
        page: 1,
        pageSize: 10,
        returnAll: true,
        getTotalCount: true,
        sortBy: [{ SourceRowIndex: 'desc' }],
      },
    );
  }

  resolveSheetUrl(path: string): string {
    return new URL(path.trim(), environment.salesSheetsCdnUrl).toString();
  }

  createExcelViewerUrl(path: string): string {
    const sheetUrl = this.resolveSheetUrl(path);
    return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(sheetUrl)}`;
  }
}
